import type { ParseKeys } from "i18next";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

export function useTranslateErrorObj() {
  const { t } = useTranslation("form");

  const getTranslatedObj = useCallback(
    function getTranslatedObj(errors: object) {
      const keys = Object.keys(errors);
      const errorObjTranslation: Record<string, string> = {};

      if (keys)
        for (const key of keys) {
          errorObjTranslation[t(key as ParseKeys<"form">)] =
            errors[key as keyof typeof errors];
        }
      return errorObjTranslation;
    },
    [t],
  );

  return { getTranslatedObj };
}
